import { productAddToCartButtonStyles } from "@insite/content-library/Components/ProductAddToCartButton";
import { productDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { css } from "styled-components";

productAddToCartButtonStyles.shape = "rounded";